import BukuNilaiTeacher from "../../../../../components/categories/siakad/lms/data_buku_nilai/HomeTeacher";
export default function Home() {
  
  return (
    <BukuNilaiTeacher />
  );
}
